export function handleApiError(error) {
    if (error.response) {
        const { status, data } = error.response;
        return {
            status,
            message: data || 'An unexpected server error occurred.',
        };
    } else if (error.request) {
        return {
            status: null,
            message: 'No response received. Try again later.',
        };
    } else {
        return {
            status: null,
            message: 'Something went wrong setting up the request.',
        };
    }
}
